import { IMenuType } from "@/lib/types/type-menu";
import { Award, BookOpen, Brain, Briefcase, Building, CircuitBoard, Code, FileText, Laptop, Library, Package, Server, Smartphone, Users } from "lucide-react";

export const Navbar_Menu_List: IMenuType[] = [
  {
    id: 1,
    title: "Services",
    path: "/",
    icon: Code,
    sublinks: [
      { id: 1, title: "Mobile App Development", path: "/mobile-app-development-services", icon: Smartphone },
      { id: 2, title: "Web App Development", path: "/web-development-services", icon: Laptop },
      { id: 3, title: "Gen-AI Development", path: "/gen-ai-development-services", icon: Brain },
      { id: 4, title: "CRM Development", path: "/crm-development-services", icon: Server },
      { id: 5, title: "Product Engineering", path: "/product-engineering", icon: CircuitBoard },
    ],
  },
  {
    id: 2,
    title: "Resources",
    path: "/",
    icon: Library,
    sublinks: [
      { id: 1, title: "Blog", path: "/blogs", icon: BookOpen },
      { id: 2, title: "Case Studies", path: "/case-studies", icon: FileText },
      { id: 3, title: "Our Tech Stack", path: "/tech-stack", icon: Server },
      { id: 4, title: "Open Source", path: "/open-source", icon: Package }
    ]
  },
  {
    id: 3,
    title: "Company",
    path: "/",
    icon: Building,
    sublinks: [
      { id: 1, title: "About Us", path: "/about-us", icon: Users },
      { id: 2, title: "Customer Success", path: "/customer-success", icon: Award },
      { id: 3, title: "Careers", path: "/careers", icon: Briefcase }
    ]
  }
];
